import ApiClient from "Store/client";

export const fetchCurrentLocationApi = () => ApiClient<TLocation>(`api/locations/current`);

export const fetchLocationApi = (locationId: string) =>
  ApiClient<TLocation>(`/api/locations/${locationId}`);

export const fetchLocationsApi = (user_id: string, queryString: string) =>
  ApiClient<TLocation[]>(`api/users/${user_id}/locations${queryString}`);

export const fetchLocationSummaryApi = (locationId: string) =>
  ApiClient<LocationSummary>(`api/locations/${locationId}/summary`);

export const updateLocationInfoApi = (body: LocationRequest) =>
  ApiClient(`api/commands/update-location`, { method: "PATCH", body, type: "text" });

export const updateLocationSubdomainApi = (body: UpdateLocationSubdomainRequest) =>
  ApiClient(`api/commands/update-location-subdomain`, { method: "PATCH", body, type: "text" });

export const updateLocationBrandingApi = (body: UpdateLocationBrandingRequest) =>
  ApiClient(`api/commands/update-location-branding`, {
    method: "PATCH",
    body,
    type: "text"
  });

export const createBrandingApi = (body: FormData) =>
  ApiClient(`api/commands/create-branding`, { method: "POST", body, type: "form-data" });

export const updateBrandingApi = (body: FormData) =>
  ApiClient(`api/commands/update-branding`, { method: "POST", body, type: "form-data" });

export const updateBrandingColorLogoApi = (body: FormData) =>
  ApiClient(`api/commands/update-branding-color-logo`, { method: "POST", body, type: "form-data" });

export const updateBrandingBlackLogoApi = (body: FormData) =>
  ApiClient(`api/commands/update-branding-black-logo`, { method: "POST", body, type: "form-data" });

export const updateBrandingBackgroundLogoApi = (body: FormData) =>
  ApiClient(`api/commands/update-branding-bg-image`, { method: "POST", body, type: "form-data" });

export const createLocationApi = (body: Partial<LocationRequest>) =>
  ApiClient(`api/commands/create-location`, { method: "POST", body });
